/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import ScrollToTopOnMount from '../components/ScrollToTopOnMount';
import Title from '../components/Title';
// import { news } from '../typings/news';
// import { INITIAL_NEWS } from '../consts/common';
import useNews from '../services/service.news';
import useStore from '../store/selectors/useStore';
import { getLocaleProperty } from '../utils/getLocaleProperty';
import '../utils/i18next';
import { useDocumentTitle } from '../hooks';
import { useTranslation } from 'react-i18next';
import { imageSrc } from '../helpers/imageSrc';
import useBindActionCreators from '../hooks/useBindActionCreators';
import { setTitle } from '../store/slices/titleSlice';
import { useDispatch } from 'react-redux';

function NewsInside() {
	const { t } = useTranslation();
	useDocumentTitle(t('news.title'));

	const { language } = useStore();
	const _baseUrl = `${process.env.REACT_APP_API_URL}/storage/`;
	const { getNews } = useNews();
	const { id: newsId } = useParams();
	const [currentNews, setCurrentNews] = useState<any>();
	const dispatch = useDispatch();
	// const { setTitle: dispatchTitle } = useBindActionCreators({ setTitle });
	const [currentImage, setCurrentImage] = useState(0);
	const [isViewerOpen, setIsViewerOpen] = useState(false);
	const openImageViewer = useCallback((index: number) => {
		setCurrentImage(index);
		setIsViewerOpen(true);
	}, []);

	const closeImageViewer = () => {
		setCurrentImage(0);
		setIsViewerOpen(false);
	};
	const navigate = useNavigate();

	let translationSlug;

	let checkIfLanguageCreated = (currentNews: {
		article: { translations: any[] };
	}) => {
		return currentNews.article?.translations?.some(
			(el: { language: { code: string } }) => el.language.code === language
		);
	};
	useEffect(() => {
		if (newsId && !currentNews) {
			getNews(newsId, language).then((news) => {
				setCurrentNews(news);
				dispatch(setTitle(news.title));
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		return () => {
			dispatch(setTitle(''));
		};
	}, []);

	useEffect(() => {
		if (
			language !== currentNews?.language?.code &&
			currentNews &&
			checkIfLanguageCreated(currentNews)
		) {
			translationSlug = currentNews?.article?.translations?.filter(
				(el: { language: { code: string }; slug: string }) => {
					if (el.language.code === language) {
						return el;
					}
				}
			);
			getNews(
				`${
					translationSlug[0]?.slug ? translationSlug[0]?.slug : currentNews.slug
				}`,
				language
			).then((news) => {
				dispatch(setTitle(news.title));
				setCurrentNews(news);
			});
			navigate(
				`/news/${
					translationSlug[0]?.slug ? translationSlug[0]?.slug : currentNews.slug
				}`,
				{ replace: true }
			);
		}
	}, [
		currentNews?.article?.translations,
		currentNews?.language?.code,
		language,
		translationSlug,
	]);

	return (
		<section className="news-inside">
			<ScrollToTopOnMount />
			<div className="container">
				<div className="news-inside__body">
					<Title size="middle" className="news-inside__title">
						{currentNews?.title}
					</Title>
					<span className="news-list__date news-inside__date">
						{currentNews?.article?.updatedAt
							.slice(0, 10)
							.split('-')
							.reverse()
							.join('-')
							.replaceAll('-', '.')}
					</span>
					<div
						className="news-inside__image"
						onClick={() => openImageViewer(0)}
					>
						{currentNews && (
							<img src={`${imageSrc(currentNews)}`} alt={currentNews?.title} />
						)}
					</div>
					{isViewerOpen && (
						<ImageViewer
							src={[`${_baseUrl}${currentNews?.image?.large.path}`]}
							currentIndex={currentImage}
							disableScroll={true}
							closeOnClickOutside={true}
							onClose={closeImageViewer}
						/>
					)}
					<div
						className="news-inside-content"
						contentEditable="false"
						dangerouslySetInnerHTML={{
							__html: currentNews?.body,
						}}
					/>
				</div>
			</div>
		</section>
	);
}

export default NewsInside;
